import ChatApp from "./components/chat";
import AllUsersPage from "./pages/AllUsersPage";
import DashboardPage from "./pages/DashboardPage";
import UserSingleOrderPage from "./pages/UserSingleOrderPage";
import ViewFormulasPage from "./pages/ViewFormulasPage";
import ViewUserProfilePage from "./pages/ViewUserProfilePage";
import NewsLetterPage from "./pages/NewsLetterSubscribersPage";
import WaitingListPage from "./pages/WaitingListPage";
const routesList: Array<IRoute> = [
  {
    path: "/",
    Component: DashboardPage,
    roles: ["ADMIN"],
    text: "Orders",
    show: true,
    Icon: "",
  },
  {
    path: "/view-users",
    Component: AllUsersPage,
    roles: ["ADMIN"],
    text: "Customers List",
    show: true,
    Icon: "",
  },
  {
    path: "/formulas",
    Component: ViewFormulasPage,
    roles: ["ADMIN"],
    text: "Formulas",
    show: true,
    Icon: "",
  },
  {
    path: "/user-profile/:userId/:fullName",
    Component: ViewUserProfilePage,
    roles: ["ADMIN"],
    text: "User Profile",
    show: false,
    Icon: "",
  },
  {
    path: "/user-orders/:orderId",
    Component: UserSingleOrderPage,
    roles: ["ADMIN"],
    text: "User Order",
    show: false,
    Icon: "",
  },
  {
    path: "/chat",
    Component: ChatApp,
    roles: ["ADMIN"],
    text: "Chat",
    show: true,
    Icon: "",
  },
  {
    path: "/news-letter",
    Component: NewsLetterPage,
    roles: ["ADMIN"],
    text: "News Letter",
    show: false,
    Icon: "",
  },
  {
    path: "/waiting-list",
    Component: WaitingListPage,
    roles: ["ADMIN"],
    text: "Waiting List",
    show: false,
    Icon: "",
  },
];
export const AppRoutes = () => {
  return routesList;
};
